export const SET_CHECKOUT_ITEMS = 'SET_CHECKOUT_ITEMS';

export const setCheckoutItems = (items) => ({
  type: SET_CHECKOUT_ITEMS,
  payload: items,
});
